module.exports = __webpack_public_path__ + "static/img/class.0602790.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/class.png
// module id = eziY
// module chunks = 0